import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useOrder } from '../../context/OrderContext';
import { Header } from '../../layout';
import Swal from 'sweetalert2';

const ProductCategorySelector = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { dispatch } = useOrder();

    // Get the type from location state (offerta or ordine)
    const orderType = location.state?.type || 'ordine';

    // Handler for selecting Ninfa category
    const handleNinfaSelect = async () => {
        // Show sub-options for Ninfa using SweetAlert2 with three options
        await Swal.fire({
            title: 'Seleziona un\'opzione',
            html: `
                <div class="space-y-3">
                    <button id="ordina-profili" class="w-full p-4 text-white rounded-lg font-medium transition-all hover:scale-[1.02] hover:shadow-lg" style="background: linear-gradient(to right, #cd212a, #a91b23);">
                        Profili
                    </button>
                    <button id="ordina-accessori" class="w-full p-4 text-white rounded-lg font-medium transition-all hover:scale-[1.02] hover:shadow-lg" style="background: linear-gradient(to right, #ef5350, #e53935);">
                        Accessori
                    </button>
                    <button id="ordina-ricambi" class="w-full p-4 rounded-lg font-medium transition-all hover:scale-[1.02] hover:shadow-lg border-2" style="background: white; color: #cd212a; border-color: #cd212a;">
                        Ricambi
                    </button>
                </div>
            `,
            icon: 'question',
            showConfirmButton: false,
            showCancelButton: true,
            cancelButtonText: 'Annulla',
            cancelButtonColor: '#991b1b',
            didOpen: () => {
                // Add event listeners to custom buttons
                document.getElementById('ordina-profili').addEventListener('click', () => {
                    Swal.close();
                    // Reset order state to start fresh (preserves cart items)
                    dispatch({ type: 'RESET_ORDER' });
                    // Navigate to order page, preserving the order type (ordine or offerta)
                    navigate('/order', {
                        state: {
                            type: orderType,
                            category: 'ninfa',
                            subCategory: 'ordina'
                        }
                    });
                });

                document.getElementById('ordina-accessori').addEventListener('click', () => {
                    Swal.close();
                    // Clear any preselected profile type from order state
                    // so users can select accessories for any ninfa kit
                    dispatch({ type: 'RESET_ORDER' });
                    // Navigate to the accessories page
                    navigate('/accessories');
                });

                document.getElementById('ordina-ricambi').addEventListener('click', () => {
                    Swal.close();
                    // Navigate to the ricambi page
                    navigate('/ricambi');
                });
            }
        });
    };

    const handleAlbaSelect = async () => {
        await Swal.fire({
            title: "Seleziona un'opzione",
            html: `
                <div class="space-y-3">
                    <button id="alba-prodotti" class="w-full p-4 text-white rounded-lg font-medium transition-all hover:scale-[1.02] hover:shadow-lg" style="background: linear-gradient(to right, #cd212a, #a91b23);">
                        Prodotti
                    </button>
                    <button id="alba-accessori" class="w-full p-4 text-white rounded-lg font-medium transition-all hover:scale-[1.02] hover:shadow-lg" style="background: linear-gradient(to right, #ef5350, #e53935);">
                        Accessori
                    </button>
                </div>
            `,
            icon: 'question',
            showConfirmButton: false,
            showCancelButton: true,
            cancelButtonText: 'Annulla',
            cancelButtonColor: '#991b1b',
            didOpen: () => {
                document.getElementById('alba-prodotti').addEventListener('click', () => {
                    Swal.close();
                    dispatch({ type: 'RESET_ORDER' });
                    navigate('/order-alba', {
                        state: { type: orderType, category: 'alba', subCategory: 'ordina' }
                    });
                });
                document.getElementById('alba-accessori').addEventListener('click', () => {
                    Swal.close();
                    dispatch({ type: 'RESET_ORDER' });
                    navigate('/order-alba', {
                        state: { type: orderType, category: 'alba', subCategory: 'accessori' }
                    });
                });
            }
        });
    };

    const handleLineaSelect = async () => {
        await Swal.fire({
            title: "Seleziona un'opzione",
            html: `
                <div class="space-y-3">
                    <button id="linea-profili" class="w-full p-4 text-white rounded-lg font-medium transition-all hover:scale-[1.02] hover:shadow-lg" style="background: linear-gradient(to right, #cd212a, #a91b23);">
                        Profili
                    </button>
                    <button id="linea-ricambi" class="w-full p-4 rounded-lg font-medium transition-all hover:scale-[1.02] hover:shadow-lg border-2" style="background: white; color: #cd212a; border-color: #cd212a;">
                        Ricambi
                    </button>
                </div>
            `,
            icon: 'question',
            showConfirmButton: false,
            showCancelButton: true,
            cancelButtonText: 'Annulla',
            cancelButtonColor: '#991b1b',
            didOpen: () => {
                document.getElementById('linea-profili').addEventListener('click', () => {
                    Swal.close();
                    dispatch({ type: 'RESET_ORDER' });
                    navigate('/order-pensiline', {
                        state: { type: orderType, category: 'pensiline', subCategory: 'ordina' }
                    });
                });
                document.getElementById('linea-ricambi').addEventListener('click', () => {
                    Swal.close();
                    navigate('/ricambi');
                });
            }
        });
    };

    return (
        <div className="min-h-screen bg-gradient-to-br from-gray-50 to-red-50">
            <div className="absolute inset-0 bg-[radial-gradient(#cd212a_0.5px,transparent_0.5px)] [background-size:24px_24px] opacity-20" />

            <Header
                backText="Dashboard"
                backTo="/dashboard"
            />

            <div className="relative container mx-auto px-4 py-8 max-w-6xl">

                <div className="mb-8">
                    <h2 className="text-xl font-medium text-gray-700 mb-4 border-b border-red-200 pb-2">
                        Seleziona una categoria di prodotti
                    </h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6 animate-fade-in">
                        <button
                            onClick={handleNinfaSelect}
                            className="bg-white border-2 border-gray-200 rounded-xl p-6 hover:border-red-500 hover:shadow-lg transition-all duration-300 flex items-center justify-center"
                        >
                            <img
                                src="/images/macrocagetorie/ninfa.png"
                                alt="Ninfa"
                                className="h-16 object-contain"
                            />
                        </button>
                        <button
                            onClick={handleAlbaSelect}
                            className="bg-white border-2 border-gray-200 rounded-xl p-6 hover:border-red-500 hover:shadow-lg transition-all duration-300 flex items-center justify-center"
                        >
                            <img
                                src="/images/macrocagetorie/alba.png"
                                alt="Alba"
                                className="h-16 object-contain"
                            />
                        </button>
                        <button
                            onClick={handleLineaSelect}
                            className="bg-white border-2 border-gray-200 rounded-xl p-6 hover:border-red-500 hover:shadow-lg transition-all duration-300 flex items-center justify-center"
                        >
                            <img
                                src="/images/macrocagetorie/linea.png"
                                alt="Linea"
                                className="h-16 object-contain"
                            />
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProductCategorySelector;
